import { AiOutlinePlus } from 'react-icons/ai';
import { FilterIcon } from '../../../../../assets/svg/filter';
import { SortIcon } from '../../../../../assets/svg/sort';
import { Button } from '../../../../../components/button/button';
import { Checkbox } from '../../../../../components/checkbox/checkbox';
import {
  DropdownFilter,
  FilterOptionType,
} from '../../../../../features/dropdown-filter/dropdown-filter';
import { DropdownSorter } from '../../../../../features/dropdown-sorter/dropdown-sorter';
import { DropdownStyleView } from '../../../../../features/dropdown-style-view/dropdown-style-view';
import { HasAccess } from '../../../../../features/has-access/has-access';
import { useModalParams } from '../../../../../hooks/use-modal-params';
import { useBranchesStore } from '../../../../../store/use-branch-store';
import { statusTitleMap } from '../use-task-list';
import { useTaskListUtils } from '../use-task-list-utils';
import s from './tasks-controls.module.css';

export const TasksControls = () => {
  const { place: branches } = useBranchesStore();
  const { t, getLocale, params, isCommon, addQueryParams } = useTaskListUtils();
  const isWidgetExpanded = params.is_expanded === '1';

  const toggleWidgetExpand = () => {
    addQueryParams({ is_expanded: isWidgetExpanded ? undefined : '1' });
  };
  const createTaskModal = useModalParams('createTask');

  return (
    <div className={s.feature}>
      <div className={s.checkbox}>
        <Checkbox
          size="md"
          label={t('Развернуть виджет')}
          checked={isWidgetExpanded}
          onClick={toggleWidgetExpand}
        />
      </div>
      <DropdownStyleView />
      <DropdownSorter
        label={t('Сортировка')}
        leftIcon={<SortIcon />}
        options={[
          { label: t('Сначала новые'), value: 'created_at', dir: 'desc' },
          { label: t('Сначала старые'), value: 'created_at', dir: 'asc' },
        ]}
      />
      <DropdownFilter
        label={t('Фильтр')}
        leftIcon={<FilterIcon />}
        options={
          [
            {
              label: t('По дате создания'),
              value: 'created_at',
              filter: 'datetime-range',
            },
            {
              label: t('По дате выполнения'),
              value: 'done_at',
              filter: 'datetime-range',
            },
            {
              label: t('По названию'),
              value: 'name',
              filter: 'input',
            },
            isCommon
              ? null
              : {
                  label: t('По QR'),
                  value: 'qrCode',
                  filter: 'input',
                },
            {
              label: t('По филиалам'),
              value: 'branch',
              filter: 'single-select',
              filterOptions: branches?.map((item) => ({
                id: String(item.id),
                value: getLocale(item.name),
              })),
            },
            {
              label: t('По ответственному'),
              value: 'employee',
              filter: 'input',
            },
            {
              label: t('По статусу'),
              value: 'status',
              filter: 'multi-select',
              filterOptions: Object.entries(statusTitleMap).map(([id, value]) => ({
                id,
                value: t(value),
              })),
            },
          ].filter(Boolean) as FilterOptionType[]
        }
      />

      {isCommon && (
        <HasAccess service="task" permissions={['write']}>
          <Button
            size="lg"
            fullWidth
            onClick={() => createTaskModal.handleOpenModal()}
            data-testid="add-task-button"
          >
            <AiOutlinePlus />
            <span className="hide__M hide__S">{t('Создать задачу')}</span>
          </Button>
        </HasAccess>
      )}
    </div>
  );
};
